import axios from "./api";
import { ApiResponse, EmailAccount, OAuthUrlResponse } from "../types/user";

export interface SendEmailRequest {
    accountId: string;
    to: string;
    subject: string;
    body: string;
    threadId?: string;
}

export const getEmailAccountsService = async () => {
    const { data } = await axios.get<ApiResponse<EmailAccount[]>>("/email-accounts");
    return data;
};

export const getEmailAccountService = async (id: string) => {
    const { data } = await axios.get<ApiResponse<EmailAccount>>(`/email-accounts/${id}`);
    return data;
};

export const deleteEmailAccountService = async (id: string) => {
    const { data } = await axios.delete<ApiResponse>(`/email-accounts/${id}`);
    return data;
};

export const testEmailAccountService = async (id: string) => {
    const { data } = await axios.post<ApiResponse>(`/email-accounts/${id}/test`);
    return data;
};

export const syncEmailAccountService = async (id: string) => {
    const { data } = await axios.post<ApiResponse>(`/email-accounts/${id}/sync`);
    return data;
};

export const setDefaultEmailAccountService = async (id: string) => {
    const { data } = await axios.put<ApiResponse>(`/email-accounts/${id}/default`);
    return data;
};

export const getGmailOAuthUrlService = async () => {
    const { data } = await axios.get<ApiResponse<OAuthUrlResponse>>("/email-accounts/oauth/gmail/url");
    return data;
};

export const gmailOAuthCallbackService = async (code: string, state: string) => {
    const { data } = await axios.post<ApiResponse>("/email-accounts/oauth/gmail/callback", { code, state });
    return data;
};

export const sendEmailService = async (payload: SendEmailRequest) => {
    const { data } = await axios.post<ApiResponse>("/email/send", payload);
    return data;
};

